import type { MenuItem, SubMenuItem } from './types';
import { PermissionAction } from './types';

/**
 * Searches the menu tree for an entry whose `route` exactly matches the given
 * route string. Checks top-level menu items first, then their subMenus.
 *
 * Returns the matched entry (MenuItem or SubMenuItem) or null if not found.
 */
export function findMenuItem(
  menu: MenuItem[],
  route: string
): MenuItem | SubMenuItem | null {
  for (const item of menu) {
    if (item.route === route) return item;
    // Backend GetMenuV2 should always emit subMenus as `[]`, but defend
    // against null on stale tokens / older API builds so a single null
    // doesn't crash the whole nav.
    for (const sub of item.subMenus ?? []) {
      if (sub.route === route) return sub;
    }
  }
  return null;
}

/**
 * Returns true when the menu tree contains an entry for `route` whose
 * `permission` array includes the numeric value of `action`.
 */
export function hasPermission(
  menu: MenuItem[],
  route: string,
  action: PermissionAction
): boolean {
  const entry = findMenuItem(menu, route);
  if (!entry) return false;
  return entry.permission.includes(action as number);
}
